import { render, staticRenderFns } from "./FooterJournal.vue?vue&type=template&id=1a9429f5"
import script from "./FooterJournal.vue?vue&type=script&lang=js"
export * from "./FooterJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports